import { Facebook, Instagram, Mail, Phone } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const TikTokIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15.2a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.73a8.19 8.19 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.16z"/>
  </svg>
);

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-card border-t border-border">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-serif font-bold text-gold mb-4">
              Currylicious Yum Yum
            </h3>
            <p className="text-muted-foreground mb-4">
              {t('footer.tagline')}
            </p>
            <div className="flex gap-4">
              <a
                href="https://m.facebook.com/profile.php?id=61584131013321"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full bg-gold/10 text-gold hover:bg-gold hover:text-background flex items-center justify-center transition-all duration-300 hover:scale-110 hover:rotate-12"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/curryliciousskanor?igsh=MTM2YzgwdHIwcjRkMA=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full bg-gold/10 text-gold hover:bg-gold hover:text-background flex items-center justify-center transition-all duration-300 hover:scale-110 hover:rotate-12"
              >
                <Instagram size={20} />
              </a>
              <a
                href="#"
                aria-label="TikTok"
                className="w-10 h-10 rounded-full bg-gold/10 text-gold hover:bg-gold hover:text-background flex items-center justify-center transition-all duration-300 hover:scale-110 hover:rotate-12"
              >
                <TikTokIcon size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-serif font-semibold text-foreground mb-4">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-muted-foreground hover:text-gold transition-all duration-300 inline-block hover:translate-x-2">
                  {t('nav.home')}
                </a>
              </li>
              <li>
                <a href="#about" className="text-muted-foreground hover:text-gold transition-all duration-300 inline-block hover:translate-x-2">
                  {t('nav.about')}
                </a>
              </li>
              <li>
                <a href="#menu" className="text-muted-foreground hover:text-gold transition-all duration-300 inline-block hover:translate-x-2">
                  {t('nav.menu')}
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-muted-foreground hover:text-gold transition-all duration-300 inline-block hover:translate-x-2">
                  {t('nav.gallery')}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-muted-foreground hover:text-gold transition-all duration-300 inline-block hover:translate-x-2">
                  {t('nav.contact')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-serif font-semibold text-foreground mb-4">
              {t('footer.contactUs')}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-muted-foreground">
                <Phone size={18} className="text-gold" />
                <a href="tel:040470060" className="hover:text-gold transition-colors">
                  040 47 00 60
                </a>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground">
                <Mail size={18} className="text-gold" />
                <a href="mailto:curryskanor@gmail.com" className="hover:text-gold transition-colors">
                  curryskanor@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border text-center text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Currylicious Yum Yum. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
